import React from "react";
import { Mail, SendHorizontal, X } from "lucide-react";

interface ResendInvitationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  email: string;
  organizationName: string;
  currentRole: string;
}

const ResendInvitationModal: React.FC<ResendInvitationModalProps> = ({
  open,
  onClose,
  onConfirm,
  email,
  organizationName,
  currentRole,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-background-paper dark:bg-background-paperDark p-6 rounded-lg shadow-lg w-full max-w-md">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h2 className="text-xl font-bold text-text-primary dark:text-text-primaryDark">
              Resend Invitation
            </h2>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="text-text-secondary dark:text-text-secondaryDark hover:text-text-primary dark:hover:text-text-primaryDark transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex items-center mb-6 bg-background-panel dark:bg-background-panelDark rounded-lg p-4">
          <Mail className="w-12 h-12 text-secondary mr-4" />
          <div>
            <p className="text-lg font-semibold text-text-primary dark:text-text-primaryDark">
              {email}
            </p>
            <p className="text-sm text-text-secondary dark:text-text-secondaryDark">
              Current Role: <strong>{currentRole}</strong>
            </p>
          </div>
        </div>

        <div className="bg-background-panel dark:bg-background-panelDark p-4 rounded-md mb-6">
          <p className="text-sm text-text-primary dark:text-text-primaryDark">
            <strong>Organization:</strong> {organizationName}
          </p>
        </div>

        <p className="text-sm text-text-secondary dark:text-text-secondaryDark mb-6">
          Resending an invitation will send a new email to{" "}
          <strong>{email}</strong>. Ensure the email address is correct before
          proceeding. This action will not affect the current invitation status
          or user role.
        </p>

        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="py-2 px-6 rounded-md text-sm font-medium border border-divider dark:border-divider-dark text-text-secondary dark:text-text-secondaryDark hover:bg-background-panel dark:hover:bg-background-panelDark transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="py-2 px-6 rounded-md text-sm font-medium bg-secondary text-white hover:bg-secondary-dark transition"
          >
            Resend Invitation
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResendInvitationModal;
